import http from '@/communication/AuthConnection'

export default ({id}) => {
  return http.get(`/v1/permission/${id}`, {id})
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/permission/ReadPermissionDetailsById.js